export default {
  QuickSearch: {
    Title: 'Tìm nhiệm vụ chi',
  },
  name: 'Họ và tên',
  dob: 'Ngày sinh',
  address: 'Địa chỉ',
  inactive: 'Ngừng kích hoạt',
  gender: 'Giới tính',
  salary: 'Lương',
  List: {
    AddBtn: 'Thêm',
    HelpBtn: 'Hướng dẫn',
    SearchEmptyText: 'Tìm kiếm',
    ActionColumn: 'Chức năng',
  },
  Detail: {
    Save: 'Lưu',
    Cancel: 'Hủy',
    Close: 'Đóng',
    ChooseRegularExplanation: 'ChooseRegularExplanation',
    clickIconCell: 'clickIconCell',
    Accept: 'Đồng ý',
    AddCondition: 'Thêm điều kiện',
    Plus: 'Dấu cộng',
    Minus: 'Dấu trừ',
    Multiply: 'Dấu nhân',
    Division: 'Dấu chia',
    OpenParenthesis: 'Dấu mở ngoặc',
    CloseParenthesis: 'Dấu đóng ngoặc',
    DeleteMark: 'Xóa',
    CheckFormula: 'Kiểm tra công thức',
    CheckFormulaSalary: 'Kiểm tra công thức thuyết minh lương',
  },
  ExplanView: {
    Custom: 'Tùy chỉnh mẫu',
    Close: 'Đóng',
  },
  DataType: {
    Kind: 'lĩnh vực',
    Chapter: 'chương',
    Source: 'nguồn kinh phí',
    SubKind: 'khoản',
    Criteria: 'tiêu chí thống kê',
    Regular: 'nhiệm vụ',
  },
  DataTypeCapitalize: {
    Chapter: 'Chương ',
    SubKind: 'Khoản ',
    Source: 'Nguồn kinh phí ',
    Criteria: 'Tiêu chí thống kê ',
  },
};
